module.exports = __webpack_public_path__ + "static/media/ic-rotate.06e83f8d.svg";